export default "__VITE_ASSET__DZhnWZn6__"